<template>
  <div class="group-manage conmon-top" style="height: 100%;">
    <el-container style="overflow-x: hidden;">
      <!--左侧分组-->
      <el-aside class="left-aside-type" width="200px" style="margin-top: 24px;margin-left: 20px">
        <div class="group-search">
          <el-input placeholder="请输入内容" v-model.trim="groupNameTmp" @keyup.enter.native="searchGroupType">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer" @click="searchGroupType"></i>
          </el-input>
        </div>
        <el-menu default-active="0" class="el-menu-vertical-demo"
          style="max-height: 850px;width:100%; border-right: none; overflow-y: auto;overflow-x:hidden;margin-bottom: 0;padding-bottom: 0"
          @open="handleOpen" @close="handleClose" text-color="#333" active-text-color="#333">
          <el-menu-item :class="item.choosen ? 'getIt' : ''" :index="index + ''" v-for="(item, index) in groups"
            :key="index" @click="chooseGroupType(item)">
            <div class="menu-btn" v-if="item.name !== '全部'">
              <i @click="editGroupTypeItem(item)" class="el-icon-edit" v-show="btnType.edit_group" style="margin-right: 0"></i>
              <i @click="deleteGroupTypeItem(item)" class="el-icon-close" v-show="btnType.del_group" style="margin-right: 10px"></i>
            </div>
            <span class="menu-title" :title="item.name">{{ item.name }}</span>
          </el-menu-item>
          <div class="add-group-btn" @click="addGroup" v-show="btnType.add_group">
            <i class="el-icon-circle-plus-outline" title="添加分组"></i>
          </div>
        </el-menu>
      </el-aside>
      <!--右侧列表-->
      <div style="padding: 0;width: 100%; overflow-x: hidden;">
        <div class="base-input ovf-hd" style="margin-bottom: 10px; overflow-x: hidden;">
          <el-row class="search-title">
            <el-col :span="4" class="table-title">
              <i class="el-icon-search" style="font-weight: bold"></i>
              <span class="order-list-search-span">筛选查询</span>
            </el-col>
            <el-col :span="20" class="text-align-right">
              <el-button class="fold-button" type="text" @click="searchHide=!searchHide" v-show="searchHide">收起查询
              </el-button>
              <el-button class="fold-button" type="text" @click="searchHide=!searchHide" v-show="!searchHide">展开查询
              </el-button>
              <i v-if="searchHide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
              <i v-if="searchHide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
              <el-button class="search-btn-new" type="primary" size="small" @click="load">查询
              </el-button>
            </el-col>
          </el-row>
          <el-row class="search-content common-search-formtype" v-show="searchHide">
            <el-col :span="24" class="text-align-left">
              <span style="margin-left: 50px">输入搜索：</span>
              <el-input placeholder="事件名称" clearable @keyup.enter.native="load" v-model.trim="search.name"></el-input>
            </el-col>
          </el-row>
        </div>
        <el-row class="search-title common-table-top" style="padding-right:0">
          <el-col :span="4" class="table-title">
            <i class="el-icon-document" style="font-weight: bold;"></i>
            <span>事件列表</span>
          </el-col>
          <el-col :span="20" class="text-align-right">
            <span style="margin-left: 20px">移到分组：</span>
            <el-select class="common-search-formtype set-event-move" style="margin-right: 13px" v-model="changeGroup_id"
              @change="confirmChooseGroupType" :disabled="checkAll" placeholder="请选择目标分组">
              <el-option v-for="item in queryGroups" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <!--<div class="add-btn">导入客户</div>-->
            <el-button type="primary" class="add-btn btn-right" v-show="btnType.add" style="float: right;" @click="addNew">新建</el-button>
          </el-col>
        </el-row>
        <!--事件列表-->
        <el-table key="tableData" class="set-event-table table-checkbox-style" id="tableData" ref="multipleTable"
          :data="tableData" v-loading="loading" @selection-change="handleSelectionChange">
          <template slot="empty">
            <div class="newTableEmpty">暂无数据，去<span @click="addNew">新建</span></div>
          </template>
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="name" label="事件名称"></el-table-column>
          <el-table-column prop="identity" label="事件id"></el-table-column>
          <el-table-column prop="score" label="评分"></el-table-column>
          <el-table-column label="操作" width="120" style="display: flex;justify-content: center">
            <template slot-scope="scope">
              <div class="op-link" v-show="btnType.edit" @click="edit(scope.row)">
                <span class="editColor">编辑</span>
              </div>
              <div class="op-link deleteColor" v-show="btnType.del" @click="deleteItem(scope.row)">
                删除
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-foot">
          <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :page-size="limit" layout="total, prev, pager, next, jumper"
            :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </el-container>
    <!--创建自定义事件弹窗-->

    <el-dialog class="cellDialog base-dialog custom-base-dialog" title="新建事件" :visible.sync="createdialog"
      width="745px">
      <el-tabs v-model="activeName">
        <el-tab-pane label="配置事件" name="配置事件">
          <div style="height: 450px; overflow-y: auto; overflow-x: hidden;">
            <el-form ref="createForm" :model="createForm" :rules="rules" class="set-attrs">
              <el-form-item :label-width="addLabelWidth" label="所属分组:">
                <el-select v-model="createForm.in_group" filterable placeholder="请选择所属分组" style="width:100%" clearable>
                  <el-option v-for="item in in_groups" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="事件名称:" :label-width="addLabelWidth" prop="name">
                <el-input maxlength="50" class="stockInput" type="text" v-model="createForm.name" auto-complete="off"
                  placeholder="事件名称"></el-input>
              </el-form-item>
              <el-form-item label="事 件 ID :" :label-width="addLabelWidth" prop="identity" class="identity-input">
                <el-input class="" type="text" v-model="createForm.identity" auto-complete="off" placeholder="事件ID">
                </el-input>
              </el-form-item>
              <el-form-item :label-width="addLabelWidth" label="评分标准:" prop="score">
                <el-input class="" type="number" v-model="createForm.score" auto-complete="off" placeholder="评分分数">
                </el-input>
              </el-form-item>
              <el-form-item :label-width="addLabelWidth" label="事件图标:" prop="icon" style="text-align: left;">
                <div class="img-content">
                  <img :src="'/static/img/event-img/' + createForm.icon" class="iconfont-img" />
                  <span class="select-icon" @click="hide = !hide">选择图标</span>
                  <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i"></i>
                  <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i"></i>
                </div>
              </el-form-item>
              <icon-font-panel v-show="hide" style="height: 230px; width: 430px;"
                v-on:selectedIconFontClass="receiveClassFromChild">
              </icon-font-panel>
              <!-- <el-form-item :label-width="addLabelWidth" label="推进等级:" class="recommend" left>
                <div class="recommend-stage">
                  <div class="recommend-stage-content" v-for="(item, index) in createForm.stage" :key="index">
                    <el-select v-model="item.user_model_id" filterable placeholder="请选择等级" @change="customerTypesChange(item)">
                      <el-option v-for="items in customerTypes" :key="items.id" :label="items.name" :value="items.id">
                      </el-option>
                    </el-select>
                    <el-select v-if="item.user_model_id !== ''" v-model="item.stage_id" filterable placeholder="请选择推进等级" style="margin-left: 10px;">
                      <el-option v-for="its in stageList[item.user_model_id]" :key="its.id" :label="its.name" :value="its.id">
                      </el-option>
                    </el-select>
                    <el-select v-if="item.user_model_id === ''" v-model="item.stage_id" disabled placeholder="请选择推进等级" style="margin-left: 10px;">
                      <el-option v-for="its in customerTypes" :key="its.id" :label="its.name" :value="its.id">
                      </el-option>
                    </el-select>
                    <div class="delete-stage" v-if="createForm.stage.length > 1" @click="deleteStageAction(index)">
                      X
                    </div>
                  </div>
                  <div class="add-stage" v-show="addStageShow" @click="addStageAction">
                    <i class="el-icon-circle-plus-outline"></i>
                    增加等级
                  </div>
                </div>
              </el-form-item>  -->
            </el-form>
            <div class="custom-attr">
              <p>事件附加属性:</p>
              <p style="font-size:12px;">在采集某些事件的时候，添加对事件的关键词描述</p>
              <div class="add-custom-attr">
                <el-button type="primary" class="add-btn object-btn" @click="addObjectAttr">字典属性</el-button>
                <el-button type="primary" class="add-btn words-btn" @click="addTextAttr">文本属性</el-button>
                <el-button type="primary" class="add-btn num-btn" @click="addNumberAttr">数量属性</el-button>
                <el-button type="primary" class="add-btn money-btn" @click="addMoneyAttr">金额属性</el-button>
              </div>
              <div class="custom-attr-item" v-for="(item, index) in attrList" :key="index">
                <span>
                  {{item.label}}：
                  <el-input v-model="item.attr_name" :disabled="item.disabled"></el-input>
                </span>
                <span style="margin:0 10px 0 15px">属 性 ID：
                  <el-input v-model="item.attr_identity" :disabled="item.disabled"></el-input>
                </span>
                <i v-if="!item.disabled" class="el-icon-close" style="line-height:36px;cursor:pointer"
                  @click="deleteCustomAttr(index)"></i>
              </div>
            </div>

          </div>
          <!-- @click="submitForm('createForm')" -->
          <div class="btns">
            <el-button class="dialog-cancel-btn" @click="createdialog = false" style="margin-right: 20px">取 消
            </el-button>
            <el-button :disabled="disabledAddEvent" class="dialog-confirm-btn" style="margin-right: 32px" type="primary"
              @click="nextAttr">下一步</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label=" 属性评分" name="属性评分" style="text-align:left">
          <AttrScore :attrList="attrList" :createFormIdentity="createForm.identity" @beforeAttr="beforeAttr"
            @addPassValue="addPassValue" />
        </el-tab-pane>
      </el-tabs>
      <!-- <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="createdialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button :disabled="disabledAddEvent" class="dialog-confirm-btn" style="margin-right: 32px" type="primary"
          @click="submitForm('createForm')">确 定</el-button>
      </div> -->
    </el-dialog>
    <!--自定义事件编辑弹窗-->
    <el-dialog class="cellDialog base-dialog custom-base-dialog" title="编辑事件" :visible.sync="editCustomdialog"
      width="745px">
      <el-tabs v-model="activeNameEdit">
        <el-tab-pane label="配置事件" name="配置事件">
          <div style="height: 450px; overflow-y: auto; overflow-x: hidden;">
            <el-form ref="createForm" :model="createForm" :rules="rules" class="set-attrs">
              <el-form-item :label-width="addLabelWidth" label="所属分组:">
                <el-select v-model="createForm.in_group" placeholder="请选择所属分组" style="width:100%" clearable>
                  <el-option v-for="item in in_groups" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="事件名称:" :label-width="addLabelWidth" prop="name">
                <el-input maxlength="50" class="stockInput" type="text" v-model="createForm.name" disabled
                  auto-complete="off" placeholder="事件名称"></el-input>
              </el-form-item>
              <el-form-item label="事 件 ID :" :label-width="addLabelWidth" prop="identity" class="identity-input">
                <el-input class="" type="text" v-model="createForm.identity" disabled auto-complete="off"
                  placeholder="事件ID">
                </el-input>
              </el-form-item>
              <el-form-item :label-width="addLabelWidth" label="评分标准:" prop="score">
                <el-input class="stockInput" type="number" v-model="createForm.score" auto-complete="off"
                  placeholder="评分分数"></el-input>
              </el-form-item>
              <el-form-item :label-width="addLabelWidth" label="事件图标:" prop="icon" style="text-align: left;">
                <div class="img-content">
                  <img :src="'/static/img/event-img/' + createForm.icon" class="iconfont-img" />
                  <span class="select-icon" @click="hide = !hide">选择图标</span>
                  <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i"></i>
                  <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i"></i>
                </div>
              </el-form-item>
              <icon-font-panel v-show="hide" style="height: 230px; width: 430px;"
                v-on:selectedIconFontClass="receiveClassFromChild">
              </icon-font-panel>
              <!-- <el-form-item :label-width="addLabelWidth" label="推进阶段:" class="recommend">
                <div class="recommend-stage">
                  <div class="recommend-stage-content" v-for="(item, index) in createForm.stage" :key="index">
                    <el-select v-model="item.user_model_id" filterable placeholder="请选择客户类型"
                      @change="customerTypesChange(item)">
                      <el-option v-for="items in customerTypes" :key="items.id" :label="items.name" :value="items.id">
                      </el-option>
                    </el-select>
                    <el-select v-if="item.user_model_id !== ''" v-model="item.stage_id" filterable placeholder="请选择推进阶段"
                      style="margin-left: 10px;">
                      <el-option v-for="it in stageList[item.user_model_id]" :key="it.id" :label="it.name"
                        :value="it.id">
                      </el-option>
                    </el-select>
                    <el-select v-if="item.user_model_id === ''" v-model="item.stage_id" disabled placeholder="请选择推进阶段"
                      style="margin-left: 10px;">
                      <el-option v-for="its in customerTypes" :key="its.id" :label="its.name" :value="its.id">
                      </el-option>
                    </el-select>
                    <div class="delete-stage" v-if="createForm.stage.length > 1" @click="deleteStageAction(index)">
                      X
                    </div>
                  </div>
                  <div class="add-stage" @click="addStageAction">
                    <i class="el-icon-circle-plus-outline"></i>
                    增加阶段
                  </div>
                </div>
              </el-form-item> -->
            </el-form>
            <div class="custom-attr">
              <p>事件附加属性:</p>
              <p style="font-size:12px;margin-bottom:20px;">在采集某些事件的时候，添加对事件的关键词描述</p>
              <div class="add-custom-attr">
                <el-button type="primary" class="add-btn object-btn" @click="addObjectAttr">字典属性</el-button>
                <el-button type="primary" class="add-btn words-btn" @click="addTextAttr">文本属性</el-button>
                <el-button type="primary" class="add-btn num-btn" @click="addNumberAttr">数量属性</el-button>
                <el-button type="primary" class="add-btn money-btn" @click="addMoneyAttr">金额属性</el-button>
              </div>
              <div class="custom-attr-item" v-for="(item, index) in attrList" :key="index">
                <span>
                  {{item.label}}：
                  <el-input v-model="item.attr_name" :disabled="item.disabled"></el-input>
                </span>
                <span style="margin:0 10px 0 15px">属 性 ID：
                  <el-input v-model="item.attr_identity" :disabled="item.disabled"></el-input>
                </span>
                <i v-if="!item.disabled" class="el-icon-close" style="line-height:36px;cursor:pointer"
                  @click="deleteCustomAttr(index)"></i>
              </div>
            </div>
          </div>
          <div class="btns">
            <el-button class="dialog-cancel-btn" @click="editCustomdialog = false" style="margin-right: 20px">取 消
            </el-button>
            <el-button :disabled="disabledAddEvent" class="dialog-confirm-btn" style="margin-right: 32px" type="primary"
              @click="extAttrEdit">下一步</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="属性评分" name="属性评分" style="text-align:left">
          <AttrEditScore :attrList="attrList" :createFormIdentity="createForm.identity" @beforeAttrEdit="beforeAttrEdit"
            @editPassValue="editPassValue" :markAttr="markAttr" />
        </el-tab-pane>
      </el-tabs>
      <!-- <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="editCustomdialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button :disabled="disabledEditEvent" class="dialog-confirm-btn" style="margin-right: 32px" type="primary"
          @click="confirmEditCreate(createForm)">确 定</el-button>
      </div> -->
    </el-dialog>
    <!--添加事件分组弹窗-->
    <el-dialog class="cellDialog base-dialog" title="创建事件分组" :visible.sync="adddialog" width="520px">
      <el-form ref="addForm" :model="addForm" :rules="addFormRules">
        <el-form-item label="分组名称:" prop="name" :label-width="addLabelWidth">
          <el-input maxlength="20" class="stockInput" type="text" v-model="addForm.name" auto-complete="off"
            placeholder="输入分组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="cancelAdd" style="margin-left: 20px">取 消</el-button>
        <el-button :disabled="disabledAdd" class="dialog-confirm-btn" type="primary" @click="confirmAdd">确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑事件分组弹窗-->
    <el-dialog class="cellDialog base-dialog" title="编辑事件分组" :visible.sync="editdialog" width="520px">
      <el-form ref="editForm" :model="editForm" :rules="editFormRules">
        <el-form-item label="分组名称:" prop="name" :label-width="addLabelWidth">
          <el-input maxlength="20" class="stockInput" type="text" v-model="editForm.name" auto-complete="off"
            placeholder="输入分组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="editdialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button :disabled="disabledEdit" class="dialog-confirm-btn" type="primary" @click="confirmEdit">确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGroupTypeList, addGroupType, deleteGroupType, getGroupList, editGroupType, deleteGroup, addGroup, confirmChooseGroupType, getCustomerList } from '@/api/customer.js'
import { getCusEventList, eventToGoup, detailCustomerEvent, editCustomerEvent, getCusEventGroupList, addCustomerEventGroup, editCustomerEventGroup, deleteCustomerEventGroup, addCustomerEvent, getCusStageList, deleteCustomerEvent, getCusTypes } from '@/api/set.js'
import IconFontPanel from './../common/icon-font-panel.vue'
import { LABEL_TYPE_OBJ } from './constant'
import AttrScore from './components/AttrScore'
import AttrEditScore from './components/AttrEditScore'
import { butonsList,getMenId } from '@/api/analyse.js'
export default {
  name: 'setEvent',
  data () {
    const checkScore = (rule, value, callback) => {
      let reg = /^-?[1-9]\d*$/
      if (value!=0) {
        if (value.length ===0) {
          callback(new Error('请输入评分标准'))
        } else if(!reg.test(parseFloat(value))) {
          callback(new Error('评分标准必须为整数'))
        }
      }
      callback()
    }
    return {
      attrScoreFormInline: {
        groupAttrRuleList: [{
          attrList: [], // 事件属性
          scoreRulesList: [{
            relationList: [],
            type: ''
          }]
        }],
        region: 'shanghai',
        input: '',
        value: ''
      },
      activeName: '配置事件',
      activeNameEdit: '配置事件',
      changeGroup_id: '',
      searchHide: true,
      hide: false,
      addStageShow: true,
      search: {
        name: ''
      },
      stageList: {},
      stageOptions: [],
      customerTypes: [],
      editFormRules: {
        name: [
          { required: true, message: '分组名称不能为空', trigger: 'change' }
        ]
      },
      addFormRules: {
        name: [
          { required: true, message: '分组名称不能为空', trigger: 'change' }
        ]
      },
      loading: true,
      disabledAdd: false,
      disabledEdit: false,
      disabledEditEvent: false,
      disabledAddEvent: false,
      group_id: '',
      limit: 10,
      page: 1,
      totalCount: 0,
      queryGroups: [],
      tableData: [],
      createdialog: false,
      editCustomdialog: false,
      adddialog: false,
      editdialog: false,
      addForm: {
        name: ''
      },
      editForm: {
        name: ''
      },
      addLabelWidth: '80px',
      editGroupTypeId: '',
      groupNameTmp: '',
      groupName: '',
      newGroupName: '',
      groups: [],
      deleteArrayIds: [],
      checkAll: true,
      isDisabled: false,
      createForm: {
        name: '',
        identity: '',
        score: '',
        stage_id: '',
        in_group: '',
        icon: 'currency.png',
        stage: [
          {
            user_model_id: '',
            stage_id: ''
          }
        ]
      },
      in_groups: [],
      rules: {
        name: [
          { required: true, message: '请输入事件名称', trigger: 'blur' }
        ],
        identity: [
          { required: true, message: '请输入事件ID', trigger: 'blur' }
        ],
        score: [
          { required: true, validator: checkScore, trigger: 'blur' }
        ],
        stage_id: [
          { required: true, message: '请输入推进等级', trigger: 'blur' }
        ]
      },
      attrList: [
        {
          label: '字典属性名称',
          attr_name: '来源',
          attr_identity: 'source',
          attr_type: 'txt',
          disabled: true
        },
        {
          label: '文本属性名称',
          attr_name: '来源内容',
          attr_identity: 'source_content',
          attr_type: 'txt',
          disabled: true
        },
        {
          label: '文本属性名称',
          attr_name: '活动营销编码',
          attr_identity: 'serial_number',
          attr_type: 'txt',
          disabled: true
        },
        {
          label: 'GEO属性名称',
          attr_name: '地理位置',
          attr_identity: 'address',
          attr_type: 'location',
          disabled: true
        }
      ],
      stage: [],
      eventId: '',
      markAttr: [],
      btnType:{
        'add_group':false,
        'edit_group':false,
        'del_group':false,
        'del':false,
        'edit':false,
        'add':false
      }
    }
  },
  computed: {
    Newitems () {
      let _this = this
      let Newitems = []
      if (_this.groupName === '') {
        return
      }
      _this.groups.map(function (item) {
        if (item.name.search(_this.groupName) != -1) {
          Newitems.push(item)
        }
      })
      return Newitems
    }
  },
  components: {
    'icon-font-panel': IconFontPanel,
    AttrScore,
    AttrEditScore
  },
  methods: {
    receiveClassFromChild (val) {
      this.createForm.icon = val
      // this.iconFontClass = val
      // this.dialogTableVisible = false
      // this.form.icon = val
    },
    queryBtnList(){
      var itemId = getMenId(this.$route.path)
       butonsList({systemCode: 'ZY_INTELLIQUOR',menuId:itemId})
        .then((res)=>{
          if(res.data.code == '200'){
            var btnList = this.btnType
            for(let i = 0, k = res.data.result.length; i < k; i ++){
              for(let m in btnList){
                if(res.data.result[i].perms.indexOf(m) != -1){
                  this.btnType[m] = true
                }
              }
            }
          }
        })
    },
    customerTypesChange (item) {
      // for (let it of this.stageList) {
      //   if (it.id === item.user_model_id) {
      //     this.stageOptions = it.stage
      //   }
      // }
    },
    // 客户模型
    loadCusTypes () {
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          this.customerTypes = res.data.result
          this.loadCustomerStage()
        }
      })
    },
    loadCustomerStage () {
      for (let one of this.customerTypes) {
        getCusStageList(one.id).then(res => {
          this.stageList[one.id] = res.data.result
        })
      }
      this.load()
    },
    // 删除推荐等级选项
    deleteStageAction (index) {
      if (this.createForm.stage.length === 1) {
        return
      }
      this.createForm.stage.splice(index, 1)
      if (this.createForm.stage.length < 10) {
        this.addStageShow = true
      }
    },
    addStageAction () {
      this.createForm.stage.push({
        user_model_id: '',
        stage_id: ''
      })
      if (this.createForm.stage.length > 9) {
        this.addStageShow = false
      }
    },
    // 选择事件分组筛选
    chooseGroupType (item) {
      this.group_id = item.id
      this.page = 1
      getCusEventList(this.page, this.limit, item.id).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.result.list
          this.totalCount = res.data.result.total
          this.loading = false
        }
      })
    },
    // 删除事件
    deleteItem (item) {
      this.$confirm('确认删除该事件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCustomerEvent(item.id).then((res) => {
          if (res.data.code == 200) {
            this.load()
            _g.toastMsg('success', '删除事件成功')
            this.adddialog = false
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 事件编辑
    edit (item) {
      this.$nextTick(()=>{
        this.$refs.createForm.resetFields() //等弹窗里的form表单的dom渲染完在执行this.$refs.staffForm.resetFields()，去除验证
      })
      this.activeNameEdit = '配置事件'
      detailCustomerEvent(item.id).then((res) => {
        if (res.data.code == 200) {
          this.markAttr = res.data.result
          let result = res.data.result
          this.editCustomdialog = true
          this.createForm.in_group = item.groupId ===0?'': item.groupId
          // for (let one of this.in_groups) {
          //   if (one.id === result.groupId) {
          //     this.createForm.in_group = result.groupId
          //   } else {
          //     this.createForm.in_group = ''
          //   }
          // }
          this.createForm.icon = result.icon
          this.createForm.name = result.name
          this.createForm.identity = result.identity
          this.createForm.score = result.score
          if (result.stageId === 0 || result.stageId === undefined) {
            this.createForm.stage_id = ''
          } else {
            this.createForm.stage_id = result.stageId
          }
          // this.attrList = JSON.parse(result.attr)
          const attrList = JSON.parse(result.attr)
          attrList.forEach(item => {
            item.label = LABEL_TYPE_OBJ[item.attr_type]
          })
          this.attrList = attrList
          // console.log(this.attrList, 'this.attrList222')
          this.eventId = result.id
          let stageArray = JSON.parse(result.stage)
          this.createForm.stage = stageArray
          for (let item of this.createForm.stage) {
            if (this.stageList[item.user_model_id] === undefined) {
              item.user_model_id = ''
              item.stage_id = ''
            }
          }
          if (this.createForm.stage.length == 0) {
            this.createForm.stage.push({
              stage_id: '',
              user_model_id: ''
            })
          }
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 请求事件列表
    load () {
      getCusEventList(this.page, this.limit, this.group_id, this.search.name).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.result.list
          this.totalCount = res.data.result.total
          this.loading = false
        }
      })
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange (page) {
      this.page = page
      this.load()
    },
    // 非系统事件 自定义事件的编辑弹窗 确定按钮
    confirmEditCreate (val) {
      console.log(val)
      this.loading = true
      let objAttr = {}
      let relas = {}
      let markAttrList = []
      let attr = {}
      val.eventGroupList.forEach((item, index) => {
        const attr_identity = item.attr_identity.split('/')[1]
        const attrList = item.attrList.find(ele => ele.attr_identity === attr_identity)
        objAttr[index] = attrList
        relas[index] = item.scoreRules.map(ele => {
          return {
            operatorType: ele.relation,
            value: ele.input,
            score: ele.score,
            symbol: ele.switch == true ? 'ADD' : 'SUBTRACT',
          }
        })

      })
      const attrs = Object.keys(objAttr)
      attrs.forEach(item => {
        markAttrList.push({
          attr: objAttr[item],
          ruleList: relas[item]
        })
      })
      console.log(markAttrList)
      for (let item = 0; item < markAttrList.length; item++) {
        if (markAttrList.length > 1) {
          if (markAttrList[item].attr == undefined) {
            _g.toastMsg('error', '请正确填写评分规则！')
            return
          } else if (markAttrList[item].attr != undefined) {
            for (let index of markAttrList[item].ruleList) {
              if (index.operatorType !== 'empty' || index.operatorType !== 'not_empty') {
                if (index.operatorType == '' || index.score == '') {
                  _g.toastMsg('error', '请正确填写评分规则！')
                  return
                }
              } else {
                if (index.operatorType == '' || index.value == '' || index.score == '') {
                  _g.toastMsg('error', '请正确填写评分规则！')
                  return
                }
              }
            }
          }

        } else if (markAttrList.length == 1) {
          for (let index of markAttrList[item].ruleList) {
            if (markAttrList[item].attr == undefined) {
              markAttrList.splice(item, 1)
            } else {
              if (index.operatorType !== 'empty' || index.operatorType !== 'not_empty') {
                if (index.operatorType == '' || index.score == '') {
                  _g.toastMsg('error', '请正确填写评分规则！')
                  return
                }
              } else {
                if (index.operatorType == '' || index.value == '' || index.score == '') {
                  _g.toastMsg('error', '请正确填写评分规则！')
                  return
                }
              }
            }
          }
        }
      }

      console.log(markAttrList)
      // for (let item of markAttrList) {
      //   for (let index of item.ruleList) {
      //     if (index.operatorType == 'empty' || index.operatorType == 'not_empty') {
      //       if (index.operatorType == '' || index.score == '') {
      //         _g.toastMsg('error', '请正确填写评分规则！')
      //         return
      //       }
      //     } else {
      //       if (index.operatorType == '' || index.value == '' || index.score == '') {
      //         _g.toastMsg('error', '请正确填写评分规则！')
      //         return
      //       }
      //     }
      //   }
      // }
      let form = JSON.parse(JSON.stringify(this.createForm))
      for (let item of this.attrList) {
        if (item.attr_name === '') {
          _g.toastMsg('error', '属性名称不能为空')
          return
        }
        if (item.attr_identity === '') {
          _g.toastMsg('error', '属性ID不能为空')
          return
        }
        let reg = new RegExp('^[a-zA-z][a-zA-z_]+$')
        if (reg.test(item.attr_identity) === false) {
          _g.toastMsg('error', '属性ID必须为字母，以字母开头，两个单词之间用下划线连接')
          return
        }
      }
      if (form.stage.length > 1) {
        for (let it of form.stage) {
          if (it.user_model_id === '' || it.stage_id === '') {
            _g.toastMsg('error', '请选择推荐等级')
            return
          }
        }
      }
      // 清理空数据
      for (let index in form.stage) {
        if (form.stage[index].user_model_id === '' || form.stage[index].stage_id === '') {
          form.stage.splice(index, 1)
        }
      }
      this.disabledEditEvent = true

      // form.icon = '/static/img/event-img/' + form.icon

      // 传给后端时去掉 label 字段
      const attrList = this.attrList.map(item => {
        const { label, ...rest } = item
        return rest
      })
      if(form.in_group === '') {
        form.in_group = 0
      }
      editCustomerEvent(this.eventId, form.name, form.identity, form.score, form.stage_id, form.in_group, attrList, form.stage, form.icon, markAttrList).then((res) => {
        if (res.data.code == 200) {
          this.editCustomdialog = false
          this.disabledEditEvent = false
          this.loadCusTypes()
          _g.toastMsg('success', '编辑成功')
        } else {
          this.disabledEditEvent = false
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 全选
    handleSelectionChange (val) {
      this.deleteArrayIds = []
      for (let i in val) {
        this.deleteArrayIds.push(val[i].id)
      }
      if (parseInt(val.length) > 0) {
        this.checkAll = false
      } else {
        this.checkAll = true
      }
    },
    // 确认移到分组
    confirmChooseGroupType () {
      eventToGoup(this.changeGroup_id, this.deleteArrayIds).then((res) => {
        if (res.data.code == 200) {
          this.changeGroup_id = ''
          this.load()
          _g.toastMsg('success', '移动成功')
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 查找群组类型
    searchGroupType () {
      let _this = this
      if (this.groupNameTmp === '') {
        for (let i in this.groups) {
          this.groups[i].choosen = false
        }
        return
      }
      let tmpNewitems = []
      this.groups.map(function (item) {
        if (item.name.search(_this.groupNameTmp) != -1) {
          tmpNewitems.push(item)
        }
      })
      let flag = 0
      for (let i in this.groups) {
        this.groups[i].choosen = false
        for (let j in tmpNewitems) {
          if (this.groups[i].id === tmpNewitems[j].id) {
            this.groups[i].choosen = true
            flag++
          }
        }
      }
      if (flag === 0) {
        _g.toastMsg('error', '没有查询到分组')
      }
    },
    // 新建
    addNew () {
      // 清空校验
      this.$nextTick(() => {
        this.$refs.createForm.resetFields() //等弹窗里的form表单的dom渲染完在执行this.$refs.staffForm.resetFields()，去除验证
      })
      this.addStageShow = true
      this.createdialog = true
      this.activeName = '配置事件'
      this.createForm.icon = 'currency.png'
      this.createForm.in_group = ''
      this.createForm.name = ''
      this.createForm.identity = ''
      this.createForm.score = ''
      this.createForm.stage_id = ''
      this.createForm.stage = [
        {
          user_model_id: '',
          stage_id: ''
        }
      ]
      this.attrList = [
        {
          label: '字典属性名称',
          attr_name: '来源',
          attr_identity: 'source',
          attr_type: 'dictionary',
          disabled: true
        },
        {
          label: '文本属性名称',
          attr_name: '来源内容',
          attr_identity: 'source_content',
          attr_type: 'txt',
          disabled: true
        },
        {
          label: '文本属性名称',
          attr_name: '活动营销编码',
          attr_identity: 'serial_number',
          attr_type: 'txt',
          disabled: true
        },
        {
          label: 'GEO属性名称',
          attr_name: '地理位置',
          attr_identity: 'address',
          attr_type: 'location',
          disabled: true
        }
      ]
    },
    // 推进等级
    loadStage () {
      // let id = this.$route.query.id
      getCusStageList().then((res) => {
        if (res.data.code == 200) {
          this.stage = res.data.result
        }
      })
    },
    // 创建自定义弹窗确定按钮
    confirmCreate (val) {
      let markAttrObj = {}
      const obj2 = {}
      val.eventGroupList.forEach((item, index) => {
        const attr_identity = item.attr_identity.split('/')[1]
        const obj = item.attrList.find(ele => ele.attr_identity === attr_identity)

        obj2[index] = obj
        markAttrObj[index] = item.scoreRules.map(ele => {
          return {
            operatorType: ele.relation,
            value: ele.input,
            score: ele.score,
            symbol: ele.switch == true ? 'ADD' : 'SUBTRACT',
          }
        })
      })
      let markAttrList = []
      const list1 = Object.keys(obj2)
      list1.forEach(item => {
        markAttrList.push({
          attr: obj2[item],
          ruleList: markAttrObj[item]
        })
      })
      console.log(markAttrList)
      for (let item = 0; item < markAttrList.length; item++) {
        if (markAttrList.length > 1) {
          if (markAttrList[item].attr == undefined) {
            _g.toastMsg('error', '请正确填写评分规则！')
            return
          } else if (markAttrList[item].attr != undefined) {
            for (let index of markAttrList[item].ruleList) {
              if (index.operatorType !== 'empty' || index.operatorType !== 'not_empty') {
                if (index.operatorType == '' || index.score == '') {
                  _g.toastMsg('error', '请正确填写评分规则！')
                  return
                }
              } else {
                if (index.operatorType == '' || index.value == '' || index.score == '') {
                  _g.toastMsg('error', '请正确填写评分规则！')
                  return
                }
              }
            }
          }

        } else if (markAttrList.length == 1) {
          for (let index of markAttrList[item].ruleList) {
            if (markAttrList[item].attr == undefined) {
              markAttrList.splice(item, 1)
            } else {
              if (index.operatorType !== 'empty' || index.operatorType !== 'not_empty') {
                if (index.operatorType == '' || index.score == '') {
                  _g.toastMsg('error', '请正确填写评分规则！')
                  return
                }
              } else {
                if (index.operatorType == '' || index.value == '' || index.score == '') {
                  _g.toastMsg('error', '请正确填写评分规则！')
                  return
                }
              }
            }
          }
        }
      }
      // for (let item of markAttrList) {
      //   for (let index of item.ruleList) {
      //     if (index.operatorType !== 'empty' || index.operatorType !== 'not_empty') {
      //       if (index.operatorType == '' || index.score == '') {
      //         _g.toastMsg('error', '请正确填写评分规则！')
      //         return
      //       }
      //     } else {
      //       if (index.operatorType == '' || index.value == '' || index.score == '') {
      //         _g.toastMsg('error', '请正确填写评分规则！')
      //         return
      //       }
      //     }
      //   }
      // }
      let form = JSON.parse(JSON.stringify(this.createForm))
      for (let item of this.attrList) {
        if (item.attr_name === '') {
          _g.toastMsg('error', '属性名称不能为空')
          return
        }
        if (item.attr_identity === '') {
          _g.toastMsg('error', '属性ID不能为空')
          return
        }
        let reg = new RegExp('^[a-zA-z][a-zA-z_]+$')
        if (reg.test(item.attr_identity) === false) {
          _g.toastMsg('error', '属性ID必须为字母，以字母开头，两个单词之间用下划线连接')
          return
        }
      }
      if (form.stage.length > 1) {
        for (let it of form.stage) {
          if (it.user_model_id === '' || it.stage_id === '') {
            _g.toastMsg('error', '请选择推荐等级')
            return
          }
        }
      }
      // 清理空数据
      for (let index in form.stage) {
        if (form.stage[index].user_model_id === '' || form.stage[index].stage_id === '') {
          form.stage.splice(index, 1)
        }
      }
      this.disabledAddEvent = true
      // form.icon = '/static/img/event-img/' + form.icon
      // 传给后端时去掉 label 字段
      const attrList = this.attrList.map(item => {
        const { label, ...rest } = item
        return rest
      })
      addCustomerEvent(form.name, form.identity, form.score, form.stage_id, form.in_group, attrList, form.stage, form.icon, markAttrList).then((res) => {
        if (res.data.code == 200) {
          this.createdialog = false
          this.disabledAddEvent = false
          this.createForm.icon = 'confirm-micro.png'
          this.load()
          _g.toastMsg('success', '添加成功')
        } else {
          this.disabledAddEvent = false
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 点击下一步
    nextAttr () {
      this.activeName = '属性评分'
    },
    extAttrEdit () {
      this.activeNameEdit = '属性评分'
    },
    addPassValue (val) {
      this.$nextTick(() => {
        this.confirmCreate(val)
      })
    },
    editPassValue (val) {
      this.$nextTick(() => {
        this.confirmEditCreate(val)
      })
    },
    // 提交
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmCreate()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 删除自定义属性
    deleteCustomAttr (index) {
      this.attrList.splice(index, 1)
    },
    // 添加自定义属性
    addTextAttr () {
      this.attrList.push(
        {
          label: '文本属性名称',
          attr_name: '',
          attr_identity: '',
          attr_type: 'txt',
          disabled: false
        }
      )
    },
    // 添加自定义字典
    addObjectAttr () {
      this.attrList.push(
        {
          label: '字典属性名称',
          attr_name: '',
          attr_identity: '',
          attr_type: 'dictionary',
          disabled: false
        }
      )
    },
    addNumberAttr () {
      this.attrList.push(
        {
          label: '数量属性名称',
          attr_name: '',
          attr_identity: '',
          attr_type: 'number',
          disabled: false
        }
      )
    },
    addMoneyAttr () {
      this.attrList.push(
        {
          label: '金额属性名称',
          attr_name: '',
          attr_identity: '',
          attr_type: 'money',
          disabled: false
        }
      )
    },
    // 添加群组分组
    addGroup () {
      this.adddialog = true
      this.addForm.name = ''
    },
    // 请求事件分组数组
    loadGroupType () {
      getCusEventGroupList().then((res) => {
        if (res.data.code == 200) {
          res.data.result.unshift({ id: '', name: '全部' })
          this.in_groups = res.data.result
          for (let item of res.data.result) {
            item.choosen = false
          }
          this.groups = res.data.result
        }
      })
    },
    // 请求事件分组数组(给select用)
    loadGroupTypes () {
      getCusEventGroupList().then((res) => {
        if (res.data.code == 200) {
          this.queryGroups = res.data.result
        }
      })
    },
    // 左侧分组导航
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    // 删除事件分组
    deleteGroupTypeItem (item) {
      this.$confirm('确认删除该分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCustomerEventGroup(item.id).then((res) => {
          if (res.data.code == 200) {
            this.loadGroupType()
            this.loadGroupTypes()
            _g.toastMsg('success', '删除事件分组成功')
            this.adddialog = false
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
      event.stopPropagation()
    },
    // 编辑事件分组
    editGroupTypeItem (item) {
      this.editdialog = true
      this.editForm.name = item.name
      this.editGroupTypeId = item.id
      event.stopPropagation()
    },
    confirmEdit () {
      this.disabledEdit = true
      editCustomerEventGroup(this.editGroupTypeId, this.editForm.name, '', '').then((res) => {
        if (res.data.code == 200) {
          this.loadGroupType()
          this.loadGroupTypes()
          _g.toastMsg('success', '编辑事件分组成功')
          this.editdialog = false
          this.disabledEdit = false
        } else {
          this.disabledEdit = false
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 创建事件分组弹窗确定
    confirmAdd () {
      this.disabledAdd = true
      addCustomerEventGroup(this.addForm.name, '').then((res) => {
        if (res.data.code == 200) {
          this.loadGroupType()
          this.loadGroupTypes()
          _g.toastMsg('success', '添加事件分组成功')
          this.adddialog = false
          this.disabledAdd = false
        } else {
          _g.toastMsg('error', res.data.message)
          this.disabledAdd = false
        }
      })
    },
    // 关闭事件分组弹窗
    cancelAdd () {
      this.adddialog = false
    },
    beforeAttr (val) {
      if (val == false) {
        this.activeName = '配置事件'
      }
    },
    beforeAttrEdit (val) {
      if (val == false) {
        this.activeNameEdit = '配置事件'
      }
    }
  },
  created () {
    this.loadCusTypes()
    this.loadGroupType()
    this.loadGroupTypes()
    this.queryBtnList()
    // this.loadStage()
  }
}
</script>

<style scoped>
.custom-attr {
  width: 495px;
  margin: 28px auto 0;
}
.custom-attr p {
  margin: 5px 15px;
  text-align: left;
}
.custom-attr-item {
  font-size: 14px;
  margin: 10px 18px 10px 13px;
  position: relative;
  display: flex;
  justify-content: space-between;
}
.add-custom-attr {
  width: 392px;
  margin: 0 auto 18px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  margin-left: 5px;
}
.add-custom-attr .add-btn {
  padding: 10px 21px;
  color: #fff;
  border-radius: 4px;
  margin: 4px 0 0 4px;
}
.el-icon-close {
  line-height: 36px;
  position: absolute;
  top: 0;
  right: -10px;
}
.num-btn {
  background: #05b324;
  border-color: #05b324;
}
.words-btn {
  background: #1980ff;
  border-color: #1980ff;
}
.object-btn {
  background: #5ee0a2;
  border-color: #5ee0a2;
}
.money-btn {
  background: #ff9f00;
  border-color: #ff9f00;
}
.name-wrapper {
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
  cursor: pointer;
}
@media only screen and (max-width: 1450px) {
  .text-align-right .fold-button-content {
    display: none;
  }
  .text-align-right .dropdown-btn-content {
    display: inline-block;
  }
}
.fold-button-content {
  float: right;
  display: inline-block;
}
.dropdown-btn-content {
  display: none;
}
.el-menu-item .menu-btn {
  display: none;
  float: right;
}
.el-menu-item:hover .menu-btn {
  display: block;
}
.disabled {
  background: #ccc !important;
}
.getIt {
  color: #ff5500 !important;
}
.cancelCreate {
  float: right;
  margin-right: 10px;
  color: #ff7373;
  cursor: pointer;
}
.el-menu-vertical-demo {
  position: relative;
}
.group-search {
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
}
.el-radio-group {
  margin-top: -13px;
}
.text-align-left {
  text-align: left;
}
.text-align-right {
  text-align: right;
}
.table-title {
  text-align: left;
}
/*  .search-title{
  background:#ecf6ff;
  border:1px solid #ebebeb;
  height:60px;
  padding:10px;
  line-height: 40px;
}*/
::-webkit-scrollbar {
  width: 6px; /*滚动条宽度*/
  height: 16px; /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px; /*滚动条的背景区域的圆角*/
  background-color: #f5f5f5; /*滚动条的背景颜色*/
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px; /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #ccc; /*滚动条的背景颜色*/
}
.el-dropdown-link {
  display: inline-block;
  background-color: #1890FF;
  height: 30px;
  line-height: 30px;
  text-align: center;
  width: 92px;
  border-radius: 20px;
  color: #fff;
  outline: none;
  margin-right: 10px;
  cursor: pointer;
}
.recommend-stage {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.recommend-stage-content {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  margin-bottom: 0px;
}
.delete-stage {
  width: 30px;
  height: 50px;
  color: #ff3333;
  cursor: pointer;
}
.add-stage {
  color: #1980ff;
}
.el-icon-circle-plus-outline {
  cursor: pointer;
}
.iconfont-img {
  height: 30px;
  margin-right: 10px;
  width: 30px;
  margin-top: -13px;
}
.select-icon {
  color: #1890FF;
  cursor: pointer;
  vertical-align: middle;
  line-height: 40px;
  display: inline-block;
  margin-bottom: 15px;
}
.search-open-close-i {
  color: #1890FF;
  vertical-align: middle;
  display: inline-block;
  line-height: 40px;
  margin-bottom: 15px;
}
.img-content {
  height: 40px;
}
</style>
